import Header from "../../app/universalComponents/Header";
import Footer from "../../app/universalComponents/Footer";
import { useEffect } from "react";

const privacySections = [
    {
        title: "Information We Collect",
        body: "When you use Tickets.NP or purchase tickets through the platform, we may collect information such as your name, email address, ticket details, order details, and any information you provide through forms on the platform.",
    },
    {
        title: "How We Use Your Information",
        body: "We use your information to process ticket purchases, send tickets and confirmations, provide customer support, manage event access, improve the platform, and communicate important updates related to your order or event.",
    },
    {
        title: "Payments",
        body: "Payments are processed securely through third-party payment providers. Tickets.NP does not store your full card details.",
    },
    {
        title: "Sharing of Information",
        body: "We may share relevant ticket and attendee information with the Event Organiser where necessary to manage entry, attendance, refunds, support, or other event-related operations.",
    },
    {
        title: "Email Communications",
        body: "We may send you emails related to your ticket purchase, including confirmations, tickets, event updates, support replies, and important notices.",
    },
    {
        title: "Data Security",
        body: "We take reasonable steps to protect your personal information. However, no online platform can guarantee complete security.",
    },
    {
        title: "Your Rights",
        body: "You may contact us to request access, correction, or deletion of your personal information, subject to any legal or operational requirements.",
    },
    {
        title: "Contact",
        body: "If you have any questions about this Privacy Policy or how your information is handled, you may contact us through the contact page on npsolved.com.",
    },
];

export default function PrivacyPage() {
    useEffect(() => {
        document.title = "Privacy Policy | Tickets.NP";
    }, []);

    return (
        <>
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-sm focus:bg-black focus:px-4 focus:py-2 focus:text-white"
            >
                Skip to main content
            </a>

            <Header sellTickets={true} />

            <main id="main-content" className="mx-6 py-10">
                <section
                    className="mx-auto max-w-4xl"
                    aria-labelledby="privacy-title"
                >
                    <p className="text-sm font-semibold uppercase tracking-widest text-gray-600">
                        Legal
                    </p>

                    <h1
                        id="privacy-title"
                        className="mt-2 text-4xl font-bold tracking-tight text-gray-950"
                    >
                        Privacy Policy
                    </h1>

                    <p className="mt-4 max-w-3xl text-sm text-gray-500">
                        This Privacy Policy explains how Tickets.NP collects,
                        uses, and protects personal information when you use the
                        platform or purchase tickets.
                    </p>
                </section>

                <section
                    className="mx-auto mt-10 max-w-4xl"
                    aria-labelledby="privacy-list-title"
                >
                    <h2 id="privacy-list-title" className="sr-only">
                        Privacy policy sections
                    </h2>

                    <ol className="space-y-6">
                        {privacySections.map((section, index) => (
                            <li
                                key={section.title}
                                className="border border-gray-300 p-6 shadow-sm"
                            >
                                <article aria-labelledby={`privacy-${index}`}>
                                    <h3
                                        id={`privacy-${index}`}
                                        className="text-xl font-bold tracking-tight"
                                    >
                                        <span
                                            aria-hidden="true"
                                            className="mr-2"
                                        >
                                            {index + 1}.
                                        </span>
                                        {section.title}
                                    </h3>

                                    <p className="mt-3 text-base">
                                        {section.body}
                                    </p>
                                </article>
                            </li>
                        ))}
                    </ol>
                </section>
            </main>

            <Footer />
        </>
    );
}